import {createRouter, createWebHistory} from 'vue-router'
import Index from '../views/Index.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'ログイン',
      shouldLogin: false,
    },
    component: () =>
      import(/* webpackChunkName: "Common" */ '../views/Login.vue'),
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () =>
      import(/* webpackChunkName: "Admin" */ '../views/admin/Index.vue'),
    children: [
      {
        path: '',
        redirect: {name: 'Home'},
      },
      {
        path: '/home',
        name: 'Home',
        meta: {
          title: 'ホーム',
          pageKey: 'Home',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Home" */ '../views/admin/home/Home.vue'
            ),
      },
      {
        path: '/opportunity-list',
        name: 'NegotiationList',
        meta: {
          title: '商談一覧',
          pageKey: 'NegotiationList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationList.vue'
            ),
      },
      {
        path: '/opportunity-detail/:id',
        name: 'NegotiationDetail',
        meta: {
          title: '商談',
          pageKey: 'NegotiationList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationDetail.vue'
            ),
      },
      {
        path: '/opportunity-detail/:id/parkinglot-editor',
        name: 'NegotiationPropertyEditor',
        meta: {
          title: '商談物件編集',
          pageKey: 'NegotiationList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationPropertyEditor.vue'
            ),
      },
      {
        path: '/opportunity-detail/:id/parkinglot-detail',
        name: 'NegotiationPropertyDetail',
        meta: {
          title: '商談物件詳細',
          pageKey: 'NegotiationList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationPropertyDetail.vue'
            ),
      },
      {
        path: '/opportunity-detail/:id/confirm-form',
        name: 'NegotiationConfirmForm',
        meta: {
          title: '確認事項フォーム',
          pageKey: 'NegotiationList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationConfirmForm.vue'
            ),
      },
      {
        path: '/opportunity-detail-phone/:id',
        name: 'NegotiationDetailPhone',
        meta: {
          title: '商談',
          pageKey: 'NegotiationListPhone',
          widthLimit: 960,
          isPhonePage: true,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationDetailPhone.vue'
            ),
      },
      {
        path: '/opportunity-list-phone',
        name: 'NegotiationListPhone',
        meta: {
          title: '商談一覧',
          pageKey: 'NegotiationListPhone',
          widthLimit: 960,
          isPhonePage: true,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Negotiation" */ '../views/admin/Negotiation/NegotiationList.vue'
            ),
      },
      {
        path: '/parkinglot-list',
        name: 'PropertyList',
        meta: {
          title: '物件一覧',
          pageKey: 'PropertyList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Property" */ '../views/admin/property/PropertyList.vue'
            ),
      },
      {
        path: '/parkinglot/:parkinglotId/parkinglot-position-list',
        name: 'ParkingPositionList',
        meta: {
          title: '車室一覧',
          pageKey: 'PropertyList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ParkingPosition" */ '../views/admin/parkingPosition/ParkingPositionList.vue'
            ),
      },
      {
        path: '/parkinglot/:parkinglotId/parkinglot-position-detail/:id',
        name: 'ParkingPositionDetail',
        meta: {
          title: '車室',
          pageKey: 'PropertyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ParkingPosition" */ '../views/admin/parkingPosition/ParkingPositionDetail.vue'
            ),
      },
      {
        path: '/parkinglot/:parkinglotId/parkinglot-position-edit/:id',
        name: 'ParkingPositionEdit',
        meta: {
          title: '車室編集',
          pageKey: 'PropertyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ParkingPosition" */ '../views/admin/parkingPosition/ParkingPositionEdit.vue'
            ),
      },
      {
        path: '/managementcompany-list',
        name: 'ManagementcompanyList',
        meta: {
          title: '取引先一覧',
          pageKey: 'ManagementcompanyList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Managementcompany" */ '../views/admin/managementcompany/ManagementcompanyList.vue'
            ),
      },
      {
        path: '/managementcompany-detail/:id',
        name: 'ManagementcompanyDetail',
        meta: {
          title: '管理会社',
          pageKey: 'ManagementcompanyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Managementcompany" */ '../views/admin/managementcompany/ManagementcompanyDetail.vue'
            ),
      },
      {
        path: '/managementcompany-edit/:id',
        name: 'ManagementcompanyEdit',
        meta: {
          title: '管理会社編集',
          pageKey: 'ManagementcompanyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Managementcompany" */ '../views/admin/managementcompany/ManagementcompanyEdit.vue'
            ),
      },
      {
        path: '/staff-detail/:id',
        name: 'StaffDetail',
        meta: {
          title: '担当者',
          pageKey: 'ManagementcompanyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Staff" */ '../views/admin/staff/StaffDetail.vue'
            ),
      },
      {
        path: '/staff-edit/:id',
        name: 'StaffEdit',
        meta: {
          title: '担当者編集',
          pageKey: 'ManagementcompanyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Staff" */ '../views/admin/staff/StaffEdit.vue'
            ),
      },
      {
        path: '/staff-add',
        name: 'StaffAdd',
        meta: {
          title: '担当者追加',
          pageKey: 'ManagementcompanyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Staff" */ '../views/admin/staff/StaffEdit.vue'
            ),
      },
      {
        path: '/parkinglot-detail/:id',
        name: 'PropertyDetail',
        meta: {
          title: '物件',
          pageKey: 'PropertyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Property" */ '../views/admin/property/PropertyDetail.vue'
            ),
      },
      {
        path: '/parkinglot-edit/:id',
        name: 'PropertyEdit',
        meta: {
          title: '物件編集',
          pageKey: 'PropertyList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Property" */ '../views/admin/property/PropertyEdit.vue'
            ),
      },
      {
        path: '/report',
        name: 'Report',
        meta: {
          title: 'レポート作成',
          pageKey: 'Report',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Report" */ '../views/admin/report/Report.vue'
            ),
      },
      {
        path: '/report-edit/:id',
        name: 'ReportEdit',
        meta: {
          title: 'レポート編集',
          pageKey: 'ReportList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Report" */ '../views/admin/report/Report.vue'
            ),
      },
      {
        path: '/report-list',
        name: 'ReportList',
        meta: {
          title: 'レポート定義一覧',
          pageKey: 'ReportList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Report" */ '../views/admin/report/ReportList.vue'
            ),
      },
      {
        path: '/report-execute/:id',
        name: 'ReportExecution',
        meta: {
          title: 'レポート実行',
          pageKey: 'ReportList',
          shouldLogin: true,
          display: 'flex'
        },
        component: () =>
          import(
            /* webpackChunkName: "Report" */ '../views/admin/report/ReportExecution.vue'
            ),
      },
      {
        path: '/dashboard',
        name: 'ReportExecutionList',
        meta: {
          title: 'ダッシュボード',
          pageKey: 'ReportExecutionList',
          shouldLogin: true,
          widthLimit: 1200,
        },
        component: () =>
          import(
            /* webpackChunkName: "dashboard" */ '../views/admin/dashboard/ReportExecutionList.vue'
            ),
      },
      {
        path: '/mailtemplate-list',
        name: 'MailTemplateList',
        meta: {
          title: 'メールテンプレート一覧',
          pageKey: 'MailTemplateList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "MailTemplate" */ '../views/admin/mailTemplate/MailTemplateList.vue'
            ),
      },
      {
        path: '/mailtemplate-detail/:id',
        name: 'MailTemplateDetail',
        meta: {
          title: 'メールテンプレート',
          pageKey: 'MailTemplateList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "MailTemplate" */ '../views/admin/mailTemplate/MailTemplateDetail.vue'
            ),
      },
      {
        path: '/mailtemplate-edit/:id',
        name: 'MailTemplateEdit',
        meta: {
          title: 'メールテンプレート編集',
          pageKey: 'MailTemplateList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "MailTemplate" */ '../views/admin/mailTemplate/MailTemplateEdit.vue'
            ),
      },
      {
        path: '/mailtemplate-new',
        name: 'MailTemplateNew',
        meta: {
          title: 'メールテンプレート追加',
          pageKey: 'MailTemplateList',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "MailTemplate" */ '../views/admin/mailTemplate/MailTemplateEdit.vue'
            ),
      },
      {
        path: '/view/:viewType/new',
        name: 'ViewNew',
        meta: {
          title: '新規ビューの作成',
          pageKey: 'ViewNew',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "View" */ '../views/admin/view/View.vue'
            ),
      },
      {
        path: '/view/:viewType/:id',
        name: 'ViewEdit',
        meta: {
          title: 'ビュー編集',
          pageKey: 'ViewEdit',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "View" */ '../views/admin/view/View.vue'
            ),
      },
      {
        path: '/report-view/new',
        name: 'ReportViewNew',
        meta: {
          title: '新規ビューの作成',
          pageKey: 'ReportViewNew',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "View" */ '../views/admin/view/ReportView.vue'
            ),
      },
      {
        path: '/report-view/:id',
        name: 'ReportViewEdit',
        meta: {
          title: 'ビュー編集',
          pageKey: 'ReportViewEdit',
          widthLimit: 1200,
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "View" */ '../views/admin/view/ReportView.vue'
            ),
      },
      {
        path: '/search-list/:keyword',
        name: 'SearchList',
        meta: {
          title: '検索結果',
          pageKey: 'SearchList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Search" */ '../views/admin/search/SearchList.vue'
            ),
      },
      {
        path: '/nearby-opportunity',
        name: 'NearbyOpportunity',
        meta: {
          title: '近隣検索',
          pageKey: 'NearbyOpportunity',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "NearbyOpportunity" */ '../views/admin/search/NearbyOpportunity.vue'
            ),
      },
      {
        path: '/area-list',
        name: 'AreaList',
        meta: {
          title: '地域一覧',
          pageKey: 'AreaList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Area" */ '../views/admin/area/AreaList.vue'
            ),
      },
      {
        path: '/area-edit/:id',
        name: 'AreaEdit',
        meta: {
          title: '地域編集',
          pageKey: 'AreaList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Area" */ '../views/admin/area/AreaEdit.vue'
            ),
      },
      {
        path: '/request-document',
        name: 'RequestDocumentList',
        meta: {
          title: '請求書一覧',
          pageKey: 'RequestDocumentList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "RequestDocument" */ '../views/admin/requestDocument/RequestDocumentList.vue'
            ),
      },
      {
        path: '/chatter/:id',
        name: 'ChatterUserList',
        meta: {
          title: 'Chatter',
          pageKey: 'ChatterUserList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ChatterUserList" */ '../views/admin/chatter/ChatterUserList.vue'
            ),
      },
      // AssessmentSearch
      {
        path: '/assessment-search',
        name: 'AssessmentSearch',
        meta: {
          title: '周辺物件検索',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentSearch.vue'
            ),
      },
      // AssessmentParkingLotSelect.vue
      {
        path: '/assessment-parkinglot-select',
        name: 'AssessmentParkingLotSelect',
        meta: {
          title: '物件選択',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentParkingLotSelect.vue'
            ),
      },
      // AssessmentSpotList
      {
        path: '/assessment-spot-list',
        name: 'AssessmentSpotList',
        meta: {
          title: 'スポット一覧',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentSpotList.vue'
            ),
      },
      // AssessmentSpotDetail
      {
        path: '/assessment-spot-detail/:id',
        name: 'AssessmentSpotDetail',
        meta: {
          title: 'スポット詳細',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
            import(
                /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentSpotDetail.vue'
                ),
      },
      // AssessmentSpotEditor
      {
        path: '/assessment-spot-editor',
        name: 'AssessmentSpotNew',
        meta: {
          title: 'スポット新規登録',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentSpotEditor.vue'
            ),
      },
      // AssessmentSpotEditor
      {
        path: '/assessment-spot-editor/:id',
        name: 'AssessmentSpotEdit',
        meta: {
          title: 'スポット編集',
          pageKey: 'AssessmentSearch',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "AssessmentSearch" */ '../views/admin/assessment/AssessmentSpotEditor.vue'
            ),
      },
      // CompetingCompanyList
      {
        path: '/competing-company-list',
        name: 'CompetingCompanyList',
        meta: {
          title: '競合会社一覧',
          pageKey: 'CompetingCompanyList',
          shouldLogin: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "CompetingCompanyList" */ '../views/admin/competingCompany/CompetingCompanyList.vue'
            ),
      },

    ],
  },
  // confirmForm
  {
    path: '/confirmForm/:uuid',
    name: 'ConfirmForm',
    meta: {
      title: '確認事項フォーム',
      pageKey: 'ConfirmForm',
      shouldLogin: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "ConfirmForm" */ '../views/confirmForm/ConfirmForm.vue'
        ),
  },
  {
    path: '/preview',
    name: 'Preview',
    meta: {
      title: 'プレビュー',
      pageKey: 'Preview',
      shouldLogin: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "Preview" */ '../views/preview/Preview.vue'
        ),
  },
  // AssessmentMap
  {
    path: '/assessment-map',
    name: 'AssessmentMap',
    meta: {
      title: '査定地図',
      pageKey: 'AssessmentMap',
      shouldLogin: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "AssessmentMap" */ '../views/admin/assessment/AssessmentMap.vue'
        ),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  console.log(to)
  const toName = to?.name
  const formName = from?.name
  const shouldLogin = to.meta.shouldLogin
  let userInfo = store.getters.userInfo
  const pageKey = to.meta.pageKey
  const title = to.meta.title || 'エリア・パーキング'
  store.dispatch('setPageKey', [pageKey])
  if (toName !== formName) {
    store.dispatch('setPageTitle', title)
    document.title = title
  }

  const isPhonePage = to.meta.isPhonePage
  if (isPhonePage || toName === 'Login') {
    document.getElementById('viewport').content = 'width=device-width, initial-scale=1.0'
  } else {
    document.getElementById('viewport').content = ''
  }

  if (shouldLogin) {
    // 如果是需要登录的页面，在判断前记录下路由信息并存储到seesionStorage中
    const newRoutObj = {
      name: to.name,
      params: to.params,
      query: to.query,
    }

    sessionStorage.setItem('lastRoute', JSON.stringify(newRoutObj))
    if (userInfo) {
      next()
    } else {
      await store.dispatch('setUserInfo')
      userInfo = store.getters.userInfo
      if (userInfo) {
        next()
      } else {
        next({name: 'Login'})
      }
    }
  } else {
    next()
  }
})

export default router
